import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
    border: {
        overflow: 'hidden',
        border: '1px solid'
    }
}));
